import { NavLink } from "react-router-dom";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

type WhatsNewLinkProps = Omit<ComponentPropsWithoutRef<typeof NavLink>, "to" | "aria-label"> & {
  readonly hasUnread: boolean;
  readonly className: string;
};

const WhatsNewLink = forwardRef<HTMLAnchorElement, WhatsNewLinkProps>(({ hasUnread, className, ...props }, ref) => (
  <NavLink
    {...props}
    ref={ref}
    to="/whats-new"
    aria-label={hasUnread ? "What’s new, unread updates available" : "What’s new"}
    className={className}
  >
    <span>What’s new</span>
    {hasUnread ? (
      <span
        aria-hidden="true"
        className="rounded-full bg-emerald-700 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white"
      >
        New
      </span>
    ) : null}
  </NavLink>
));

WhatsNewLink.displayName = "WhatsNewLink";

export default WhatsNewLink;
